import React, { useState , useEffect} from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Skanda.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';

import city from '../../../city.json'


import axios from 'axios';



const formatTime = (fullStr, format = '12hr') => {
  if (typeof fullStr !== 'string') return '--';

  // Match time with optional AM/PM
  const match = fullStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);

  if (!match) return fullStr; // If no match, return original string

  let [_, hh, mm, period] = match;
  let hours = parseInt(hh, 10);
  const minutes = parseInt(mm, 10);

  let replacementTime = '';

  if (format === '24hr' || format === '24hr+') {
    // Convert to 24-hour format
    if (period?.toUpperCase() === 'PM' && hours !== 12) hours += 12;
    if (period?.toUpperCase() === 'AM' && hours === 12) hours = 0;

    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');

    replacementTime = `${paddedHours}:${paddedMinutes}`;
    if (format === '24hr+') {
      replacementTime += ':00'; // add seconds
    }
  } else {
    // 12-hour format
    let suffix = period;
    if (!suffix) {
      suffix = hours >= 12 ? 'PM' : 'AM';
    }

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }

    replacementTime = `${hours}:${mm} ${suffix.toUpperCase()}`;
  }

  // Replace only the matched time part in the original string
  return fullStr.replace(match[0], replacementTime);
};

const Skanda = () => {
  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('kolkata');
  const [timeFormat, setTimeFormat] = useState('12');

  const [SkandaList, setSkandaList] = useState([]);
   const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedSkanda, setSelectedSkanda] = useState(null);


  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };


  const skandaSashtiTooltips = {
  "Skanda Sashti": "Skanda Sashti is observed on the sixth day (Shashthi) of the lunar fortnight in honor of Lord Murugan (Kartikeya). Devotees fast and perform special pujas to seek blessings, victory over obstacles, and protection from evils."
};


useEffect(() => {
  const fetchskandaData = async () => {
    try {
     if (!location || location.trim() === '') return;
      const response = await axios.get(
        `https://core-c343.onrender.com/api/skanda-sashti?year=${year}&location=${encodeURIComponent(location)}`
      );
      
     
      if (response.data && response.data.skandaSashtiDates) {
        setSkandaList(response.data.skandaSashtiDates);
      } else {
        setSkandaList([]);
      }
   
 
    } catch (error) {
      console.error("Failed to fetch skanda data:", error);
      setSkandaList([]);
    }
  };

  fetchskandaData();
}, [year, location]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());


  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });
  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

const handleSelect = (cityName) => {
  setTempLocation(cityName);
  setLocation(cityName); // 🔥 REQUIRED
  setSuggestions([]);
};



  return (
    <div className="Skanda-container">
      <InnerNav />
      <div className="Skanda-content">
        <Zodiac />

        {/* Ekadashi Calendar JSX starts here */}
        <div className="calendar-wrapper">
          <div className="calendar-header dark">
            <div className="highlight">
              <h2>{year} Skanda Sasthi Dates</h2>
              <div className="current-ekadashi">
                <img src="https://sanity-admin.rudraksha-ratna.com/static/images/blogs/5979332009.jpg" alt="Moon" className="moon-preview" />
                <div>
                 
                  <p>{location}</p>
                </div>
                <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
              </div>

              <div className="Skanda-controls">
                <div className="location-date">
                  <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  
                </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>
                    12 Hour
                  </button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>
                    24 Hour
                  </button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>
                    24 Plus
                  </button>
                  </div>
              </div>
            </div>
          </div>

{!selectedSkanda ? (
  <div className="skanda-list">
    {SkandaList.length === 0 && (
      <p>No skanda sasthi data available for selected year/location.</p>
    )}

    {SkandaList.map((item, idx) => (
      <div
        className="skanda-item clickable"
        key={idx}
        onClick={() => setSelectedSkanda(item)}
      >
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQjWEo5aSh_yGrRANIG1JdKX_kDwFgUgYsJhw&s"
          alt={item.title}
        />

        <div className="skanda-details">
          <p className="skanda-date">{item.date}</p>

          {/* <div className="tooltip-wrapper">
            <div className="skanda-name">{item.title}</div>
            <span className="tooltip-text">
              {skandaSashtiTooltips[item.title] || "No info available"}
            </span>
          </div> */}
          <div className="skanda-name">{item.title}</div>


          <p className="skanda-phase">{item.nakshatra}</p>
          <p className="skanda-tithi">{item.tithiName}</p>
          <p className="skanda-tithi">{item.duration}</p>
        </div>

        <div className="skanda-timings">
          <p>{item.lunarDetail}</p>
          <p>{formatTime(item.tithiStart, timeFormat)}</p>
          <p>{formatTime(item.tithiEnd, timeFormat)}</p>
        </div>
      </div>
    ))}
  </div>
) : (
  <div className="san-detail-view">
    <button className="back-btn" onClick={() => setSelectedSkanda(null)}>
      ← Back
    </button>

    <h2>{selectedSkanda.title}</h2>

    <img
      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQjWEo5aSh_yGrRANIG1JdKX_kDwFgUgYsJhw&s"
      alt={selectedSkanda.title}
    />

    {/* META INFO */}
    <div className="detail-grid">
      <div><strong>Date:</strong> {selectedSkanda.date}</div>
      <div><strong>Day:</strong> {new Date(selectedSkanda.date).toLocaleDateString('en-US', { weekday: 'long' })}</div>
      <div><strong>Location:</strong> {location}</div>
      <div><strong>Year:</strong> {year}</div>
    </div>

    {/* MAIN DETAILS */}
    <div className="detail-grid">
      {/* <div><strong>Nakshatra:</strong> {selectedSkanda.nakshatra}</div> */}
      <div><strong>Tithi:</strong> {selectedSkanda.tithiName}</div>
      <div><strong>Duration:</strong> {selectedSkanda.duration}</div>
      <div><strong>Lunar Detail:</strong> {selectedSkanda.lunarDetail}</div>
    </div>

    {/* TITHI TIMINGS */}
    <div className="detail-section">
      <h3>Tithi Timings</h3>
      <p><strong>Start:</strong> {formatTime(selectedSkanda.tithiStart, timeFormat)}</p>
      <p><strong>End:</strong> {formatTime(selectedSkanda.tithiEnd, timeFormat)}</p>
    </div>

    {/* SIGNIFICANCE */}
    {skandaSashtiTooltips[selectedSkanda.title] && (
      <div className="detail-section">
        <h3>Significance</h3>
        <p>{skandaSashtiTooltips[selectedSkanda.title]}</p>
      </div>
    )}
  </div>
)
}

        </div>
        {/* Ekadashi Calendar JSX ends here */}

         <section className="skanda-wrapper">
      <h1 className="skanda-title">Skanda Sashti, Kanda Sashti Vratam</h1>
      <div className="skanda-texts">
        <p>
          Skanda is a popular Hindu deity especially among Tamil Hindus. Lord Skanda is son of God Shiva and Goddess Parvati. In South India, Skanda is considered as the younger brother of Lord Ganesha while in North India Skanda is considered as the elder brother of Lord Ganesha. God Skanda is also known as Murugan, Kartikeyan and Subramanya.
        </p>
        <p>
          Sashti Tithi is dedicated to Lord Skanda. Devotees keep fast during Shukla Paksha Sashti day. For Skanda Sashti Vratam the day when Sashti Tithi is combined with Panchami Tithi is preferred. Hence Skanda Sashti Vratam might be observed on Panchami Tithi.
        </p>
        <p>
          Skanda Sashti is also known as Kanda Shashti.
        </p>
        <p>
          When Panchami Tithi ends or Sashti Tithi starts between sunrise and sunset then both Panchami and Sashti are conjugated and this day is chosen for Skanda Sashti Vratam. This rule has been mentioned in Dharmasindhu and Nirnayasindhu. Many Murugan temples in Tamil Nadu, including famous Sri Subrahmanya Swami Devasthanam in Tiruchendur, follow the same rule and Soorasamharam day is observed one day before Sashti Tithi if on previous day Sashti Tithi is combined with Panchami Tithi.
        </p>
        <p>
          Although all Sashti(s) are dedicated to Lord Murugan but Shukla Paksha Sashti during lunar month Kartika (which is during Solar month Aippasi or Karthikai) is the most significant one. Devotees observe six days fast which lasts on Soorasamharam day. Next day after Soorasamharam is known as Tiru Kalyanam.
        </p>
        <p>
          Next Skanda Sashti after Soorasamharam is known as Subramanya Sashti which is also known as Kukke Subramanya Sashti and falls during lunar month Margashirsha.
        </p>
        <h2 className="skanda-subtitle">Temples Dedicated to Lord Murugan</h2>
        <p>Following six abodes, which are known as Arupadaiveedu, are the most important shrines for Murugan devotees in Tamil Nadu, India.</p>
        <ul className="skanda-temples">
          <li>Palani Murugan Temple (100 km south east of Coimbatore)</li>
          <li>Swamimalai Murugan Temple (Near Kumbakonam)</li>
          <li>Thiruthani Murugan Temple (84 km from Chennai)</li>
          <li>Pazhamudircholai Murugan Temple (10 km north of Madurai)</li>
          <li>Sri Subrahmanya Swami Devasthanam, Tiruchendur (40 km south of Thoothukudi)</li>
          <li>Thirupparamkunram Murugan Temple (10 km south of Madurai)</li>
        </ul>
        <p>
          Marudamalai Murugan Temple (a suburb of Coimbatore) is another important shrine.
        </p>
        <p>
          Kukke Subramanya Temple, near Mangalore, Karnataka, India is also very famous shrine dedicated to Lord Murugan but it is not part of six abodes of Lord Murugan which are located in Tamil Nadu.
        </p>
      </div>
    </section>
            <VratLinks/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default Skanda;
